<template>
  <div class="demo-disclaimer-container">
    <div class="disclaimer-banner">
      <div class="disclaimer-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </div>
      <div class="disclaimer-content">
        <h3 class="disclaimer-title">{{ disclaimer?.title || '⚠️ ILLUSTRATIVE EXAMPLE ONLY' }}</h3>
        <p class="disclaimer-message">{{ disclaimer?.message || 'This is an educational example.' }}</p>
        <p class="disclaimer-cta">{{ disclaimer?.cta || 'Sign up for actual recommendations.' }}</p>
        <ANButton
          label="Sign Up Now for Personalized Advice"
          variant="primary"
          icon="pi pi-user-plus"
          @click="handleSignUp"
          class="signup-btn"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import ANButton from '@/components/common/AnButton.vue'
import { inject } from 'vue'

const props = defineProps({
  disclaimer: {
    type: Object,
    required: false,
    default: () => ({
      title: '⚠️ ILLUSTRATIVE EXAMPLE ONLY - NOT AN INVESTMENT RECOMMENDATION',
      message: 'This allocation is a generic example for educational purposes. Actual investment recommendations require SEBI-compliant KYC verification, signed Investment Advisory Agreement, and active subscription.',
      cta: 'Sign up to receive personalized, SEBI-compliant investment recommendations.'
    })
  }
})

// Try to get setAuth function from parent component
const setAuth = inject('setAuth', null)

const handleSignUp = () => {
  // If setAuth is available from parent, use it (same as header "Get Started" button)
  if (setAuth && typeof setAuth === 'function') {
    setAuth(true, 'signup')
  } else {
    // Fallback: emit custom event
    window.dispatchEvent(new CustomEvent('open-auth-modal', { detail: { view: 'signup' } }))
  }
}
</script>

<style scoped>
.demo-disclaimer-container {
  margin-bottom: 32px;
}

.disclaimer-banner {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 24px;
  background: linear-gradient(135deg, #fff3cd 0%, #ffe69c 100%);
  border: 3px solid #ffc107;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(255, 193, 7, 0.3);
}

.disclaimer-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  background: #ffc107;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #856404;
  font-size: 24px;
}

.disclaimer-content {
  flex: 1;
}

.disclaimer-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #856404;
  margin: 0 0 12px 0;
  line-height: 1.3;
}

.disclaimer-message {
  font-size: 1rem;
  color: #856404;
  margin: 0 0 12px 0;
  line-height: 1.6;
}

.disclaimer-cta {
  font-size: 1rem;
  font-weight: 600;
  color: #533f03;
  margin: 0 0 16px 0;
}

.signup-btn {
  background: #ffc107;
  color: #856404;
  font-weight: 600;
  border: 2px solid #856404;
}

.signup-btn:hover {
  background: #ffb300;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.4);
}

/* Responsive */
@media (max-width: 768px) {
  .disclaimer-banner {
    flex-direction: column;
    text-align: center;
    padding: 20px;
  }

  .disclaimer-icon {
    margin: 0 auto;
  }

  .disclaimer-title {
    font-size: 1.1rem;
  }

  .disclaimer-message,
  .disclaimer-cta {
    font-size: 0.9rem;
  }

  .signup-btn {
    width: 100%;
  }
}
</style>
